export default "__VITE_ASSET__fcpC$BYE__"